import type { FaireProductEntity } from "../../entity_types/product";

export const p_g5629m787b: FaireProductEntity = {
  token: "p_g5629m787b",
  type: "product",
  name: "Marble Palo Santo Holder",
  brandToken: "b_pqhb98yzxr",
  brandName: "Mi Esperanza Minerals",
  imageUrl:
    "https://cdn.faire.com/fastly/ed5f3b8545a06d71f8417e10b6968e901a95ceec101e94d5f2037d2615c41b62.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/77b19ae06db6cd56c52a9028cd05828abf7f3b0b57b902ce31988b3d5318ae22.jpeg",
    "https://cdn.faire.com/fastly/24eb7174c4fb31cc9397d76e6d0cf496f6bd2e26f5025b5cce166eebc0f1d9b0.jpeg",
    "https://cdn.faire.com/fastly/aaa8bce1159bfd0694160aaffb4f9050998b1afde50d28a6dbfd20de6d8c51fe.jpeg",
    "https://cdn.faire.com/fastly/a583c70988b654cc0517ffc45f930d08fd3fbfb9dbee123a370c01bc37335fd7.jpeg",
    "https://cdn.faire.com/fastly/bd14260ce88c860859d7f4a34dac27ab34911341d64e48fdf3f8f956e00e7509.jpeg",
  ],
  priceDollars: 19.4,
  description:
    'You will receive one set of the same size and quality as the palo santo holders pictured.\n\nPurchase includes one palo santo holders.\n\nCool and veining pattern will vary slightly.\n\nMade in Mexico.\n\nApproximate size: 4.75"x 2"\n',
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:55.550Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
